import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=755f023e&scoped=true&"
import script from "./SubCategory.vue?vue&type=script&lang=js&"
export * from "./SubCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=755f023e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f023e",
  null
  
)

export default component.exports